<template>
    <div class="ws_common_modal">
        <div class="ws_common_modal_body">
            <div class="ws_common_modal_header">
                <!-- <h2>Are you sure you want to close this session?"</h2>
                <p>All messages in the chat will be cleared. Would you like to clear this conversation?</p> -->
                <h2>Are you sure you want to exit?</h2>
                <p>All the Chat History will be lost! </p>
                <div class="form-group">
                    <label>How would you rate this chat so far?</label>
                    <star-rating :animate="true" :rating.sync="currentRating" size="20" :star-type="'fa fa-star'" 
                        v-model="currentRating" inactive-color="#ffffff" active-color="#ffd400" :show-rating="false" />
                    <!-- <textarea type="text" class="form-control" v-model="comment" rows="4" ></textarea> -->
                </div>
                <span class="ws_common_modal_close">
                    <svg height="10px" viewBox="0 0 329.26933 329" width="10px" xmlns="http://www.w3.org/2000/svg" @click="popupCloseMethod"><g fill="#f44336"><path d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0"></path><path d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0"></path></g></svg>
                </span>
            </div>
            <div class="ws_common_modal_btn">
                <button class="btn btn-danger" @click="popupCloseMethod">Cancel</button>
                <button class="btn btn-success" @click="ratingSubmitMethod" :disabled="isSubmitted">Yes, I want</button>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';
import StarRating from 'vue-star-rating';
export default {
    props: ['socket', 'sessionId'],
    name: 'botCloseConfirmation',
    components: {
        StarRating, // Register the component
    },
    data() {
        return {
            currentRating: 0,
            isSubmitted:false
        };
    },
    mounted() {
    },
    methods: {
        ratingSubmitMethod(){
            if(this.socket && this.currentRating > 0) {
                // const data = {
                //     type: "session_rating",
                //     rating:this.currentRating
                // }
                // this.socket.send(JSON.stringify(data));
                // this.$nextTick(() => {
                //     this.botClosesConfirmedMethod();
                // });
                const data = {
                    session_id: this.sessionId,
                    rating:this.currentRating
                }
                this.isSubmitted = true;
                this.$store.dispatch('tukivitaSessionRateAction', data).then((res) => {
                   this.isSubmitted = false;
                    this.$nextTick(() => {
                        this.botClosesConfirmedMethod();
                    });
                }).catch((err) => {
                   this.isSubmitted = false;
                })
            }else{
                this.botClosesConfirmedMethod();
            }
        },
        popupCloseMethod(){
            bus.$emit('botClosesPopupBus', false)
        },
        botClosesConfirmedMethod(){
            bus.$emit('botClosesConfirmed', true)
        }
    }
}
</script>

<style lang="scss" scoped>
.ws_common_modal {
    background: linear-gradient(-30deg, rgba(37, 44, 84, 0.95), rgba(0, 0, 0, 0.95) 50%, rgba(38, 38, 38, 0.95) 0, rgba(44, 44, 84, 0.95));
    border-radius: 10px 10px 15px 15px;
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 100px 20px 0px;


    .ws_common_modal_body {
        background: linear-gradient(-30deg, rgba(37, 44, 84, 1), rgba(0, 0, 0, 1) 50%, rgba(38, 38, 38, 1) 0, rgba(44, 44, 84, 1));
        width: 100%;
        border-radius: 10px;
        border: 1px solid rgba(93, 93, 93, .5);
        padding: 30px 15px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;
        box-shadow: 0px 0px 15px rgba(255, 213, 0, 0.2);
        position: relative;
        text-align: center;
    }

    .ws_common_modal_header {
        h2 {
         color: #ffec97;
        font-size: 20px;
        line-height: 1.2;
        margin-bottom: 10px;
        }

        p {
            color: #d8d8d8;
            font-size: 14px;
            line-height: 1.4;
            margin-bottom: 15px;
        }
        .ws_common_modal_close{
            position: absolute;
            top: 3px;
            right: 8px;
            svg{
                cursor: pointer;
                &:hover path{
                    fill: #87cefa;
                }
            }
        }
    }

    .ws_common_modal_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        padding: 25px 15px 0px;
        margin: 30px -15px 0px;
        border-top: 1px solid #d8d8d824;

        .btn {
            font-size: 16px;
            padding: 8px 5px;
            min-width: 100px;
            line-height: 1;
            border-radius: 3px;
            outline: none !important;
            border: none !important;
            box-shadow: none !important;

            &:hover {
                background: #ffe738 !important;
                color: #22292f !important;
            }

            &.btn-danger {
                background: rgba(255, 18, 18, 0.5);
                color: #fff;
            }

            &.btn-success {
                background: rgba(33, 228, 0, 0.5);
                color: #fff;
            }
        }
    }
}
</style>
<style lang="scss">
.vue-star-rating{justify-content: center;}
</style>